import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'custom-panel',
    templateUrl: './custom-panel.component.html',
    styleUrls: ['./custom-panel.component.scss'],
})
export class CustomPanelComponent {
    @Input() header = '';
    @Input() subtitle = '';
    @Input() saveButtonText = '';
    @Input() resetButtonText = '';
    @Input() saveDisabled = false;
    @Input() resetDisabled = false;
    @Input() areButtons = true;

    @Output() componentSave: EventEmitter<any> = new EventEmitter();
    @Output() componentReset: EventEmitter<any> = new EventEmitter();

    save() {
        this.componentSave.emit();
    }

    reset() {
        this.componentReset.emit();
    }
}
